<div class="full-height layout-column"
     [ngbTooltip]="bringozCapacityTooltip" openDelay="300" triggers="hover">
  <!--Column Layout-->
  <div *ngIf="!isLayoutRow" class="layout-column">

    <div class="layout-row layout-align-start-center margin-bottom-5">
      <bringoz-icon iconName="weight" class="margin-right-5 gray-102"></bringoz-icon>

      <div *ngIf="totalWeight" class="flex layout-row layout-align-start-center">
        <app-bringoz-capacity-bar class="flex"
                                  [value]="weight ? (weight / totalWeight * 100) : 0">

        </app-bringoz-capacity-bar>

        <span class="br-caption-1 font-weight-500 margin-left-5">{{ (weight ? (weight / totalWeight * 100) : 0) | number: '1.0-0'}}
          %</span>
      </div>

      <span *ngIf="!totalWeight"
            class="br-body-1">{{weight || 0 | number:weight % 1 > 0 ? '1.0-1' : '1.0-0' }} {{weightUnit | translate}}
        / {{'UNLIMITED' | translate}}</span>
    </div>

    <div class="layout-row layout-align-start-center">
      <bringoz-icon iconName="volume" class="margin-right-5 gray-102"></bringoz-icon>

      <div *ngIf="totalVolume" class="flex layout-row layout-align-start-center">
        <app-bringoz-capacity-bar class="flex"
                                  [value]="volume ? (volume / totalVolume * 100) : 0">

        </app-bringoz-capacity-bar>

        <span class="br-caption-1 font-weight-500 margin-left-5">{{ (volume ? (volume / totalVolume * 100) : 0) | number: '1.0-0'}}
          %</span>
      </div>

      <span *ngIf="!totalVolume"
            class="br-body-1">{{volume || 0 | number:volume % 1 > 0 ? '1.0-1' : '1.0-0' }} {{volumeUnit | translate}}
        / {{'UNLIMITED' | translate}}</span>
    </div>

    <div *ngIf="showPackages"
         class="layout-row layout-align-start-center margin-top-5"
         [ngClass]="{'error': totalPackages > packages}">
      <bringoz-icon iconName="package-outline" class="margin-right-5 gray-102"></bringoz-icon>

      <div *ngIf="totalPackages" class="flex layout-row layout-align-start-center">
        <app-bringoz-capacity-bar class="flex"
                                  [value]="packages ? (packages / totalPackages * 100) : 0">

        </app-bringoz-capacity-bar>

        <span class="br-caption-1 font-weight-500 margin-left-5">{{ (packages ? (packages / totalPackages * 100) : 0) | number: '1.0-0'}}
          %</span>
      </div>


      <span *ngIf="!totalPackages"
            class="br-body-1">{{packages || 0 | number:packages % 1 > 0 ? '1.0-1' : '1.0-0'}}
        / {{'UNLIMITED' | translate}}</span>
    </div>

    <div *ngIf="showPackages" class="layout-row layout-align-start-center margin-top-5">
      <bringoz-icon iconName="pallets" class="margin-right-5 gray-102"></bringoz-icon>
      <span *ngIf="totalPallets" class="br-body-1"> {{pallets ? pallets : 0 }}
        / {{ totalPallets}} </span>
      <span *ngIf="!totalPallets"
            class="br-body-1">{{pallets || 0 | number:pallets % 1 > 0 ? '1.0-1' : '1.0-0'}}
        / {{'UNLIMITED' | translate}}</span>
    </div>

    <div *ngIf="showPackages" class="layout-row layout-align-start-center margin-top-5">
      <bringoz-icon iconName="spot" class="margin-right-5 gray-102"></bringoz-icon>
      <span *ngIf="totalSpots" class="br-body-1"> {{spots ? spots : 0 }}
        / {{ totalSpots}} </span>
      <span *ngIf="!totalSpots"
            class="br-body-1">{{spots || 0 | number:spots % 1 > 0 ? '1.0-1' : '1.0-0'}}
        / {{'UNLIMITED' | translate}}</span>
    </div>

  </div>

  <!--Row Layout-->
  <div *ngIf="isLayoutRow" class="layout-row layout-align-start-center">

    <div class="layout-row layout-align-start-center margin-right-5">
      <bringoz-icon iconName="weight" class="margin-right-5 gray-102"></bringoz-icon>

      <div *ngIf="totalWeight" class="flex layout-row layout-align-start-center">
        <app-bringoz-capacity-bar class="flex"
                                  [value]="weight ? (weight / totalWeight * 100) : 0">

        </app-bringoz-capacity-bar>

        <span class="br-caption-1 font-weight-500 margin-left-5">{{ (weight ? (weight / totalWeight * 100) : 0) | number: '1.0-0'}}
          %</span>
      </div>

      <span *ngIf="!totalWeight"
            class="br-body-1">{{weight || 0 | number:weight % 1 > 0 ? '1.0-1' : '1.0-0' }} {{weightUnit | translate}}
        / {{'UNLIMITED' | translate}}</span>

    </div>

    <div class="layout-row layout-align-start-center margin-right-5">
      <bringoz-icon iconName="volume" class="margin-right-5 gray-102"></bringoz-icon>

      <div *ngIf="totalVolume" class="flex layout-row layout-align-start-center">
        <app-bringoz-capacity-bar class="flex"
                                  [value]="volume ? (volume / totalVolume * 100) : 0">

        </app-bringoz-capacity-bar>

        <span class="br-caption-1 font-weight-500 margin-left-5">{{ (volume ? (volume / totalVolume * 100) : 0) | number: '1.0-0'}}
          %</span>
      </div>

      <span *ngIf="!totalVolume"
            class="br-body-1">{{volume || 0 | number:volume % 1 > 0 ? '1.0-1' : '1.0-0' }} {{volumeUnit | translate}}
        / {{'UNLIMITED' | translate}}</span>
    </div>
  </div>

  <ng-template #bringozCapacityTooltip>
    <div class="layout-column layout-align-center-start gap-5">
      <div class="layout-row layout-align-start-center gap-5" layout="row" layout-align="start center">

        <span translate>Total</span>

        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="weight" class="margin-right-5 gray-102"></bringoz-icon>
          <span style="color: #7E7E7E;">{{weight | bringozWeight:true}}</span>
        </div>

        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="volume" class="margin-right-5 gray-102"></bringoz-icon>
          <span style="color: #7E7E7E;">{{volume | bringozVolume:true}}</span>
        </div>

        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="package-outline" class="margin-right-5 gray-102"></bringoz-icon>
          <span style="color: #7E7E7E;">{{packages || '--'}}</span>
        </div>
      </div>
    </div>
  </ng-template>
</div>
